import React, { Component } from 'react';
import styles from './TableView.module.css';
import Checkbox from 'rc-checkbox';
import ConfigPanel from '../ConfigPanel';
import Waypoint from 'react-waypoint';

export default class TableView extends Component {
  state = {
    filterAlphabet: null,
    filter: null,
    checked: {},
    active: {},
  };

  componentDidMount() {
    const { data, hasChildren, selected } = this.props;
    if (hasChildren) {
      const active = data.reduce((acc, el) => {
        acc[el[0]] = false;
        return acc;
      }, {});
      this.setState({ active });
    }
    if (selected) {
      const checked = Object.assign({}, selected);
      this.setState({ checked });
    }
  }

  componentWillReceiveProps = props => {
    const checked = {};
    const { headers } = this.props;
    for (let i in props.selected) {
      checked[headers[0]] = true;
      checked[i] = true;
    }
    this.setState({ checked });
  };

  toggleActive = (v, k) => {
    if (v && v.onClick) return v.onClick(v.value);
    const { active } = this.state;
    const { hasChildren, onClick } = this.props;
    if (!hasChildren && !onClick) return;
    const product = typeof v === 'object' ? v.value : v;
    if (onClick && k === 0) {
      onClick(product);
      return;
    }
    active[product] = !active[product];
    this.setState({ active });
  };

  filterTag = item => {
    const { filterAlphabet } = this.state;
    const { filter } = this.props;
    const key = typeof item[0] === 'object' ? item[0].label : item[0];
    if (filter) {
      return key.indexOf(filter) !== -1;
    }
    if (filterAlphabet) {
      return key[0].toUpperCase() === filterAlphabet;
    }
    return true;
  };

  renderTable = (headers, content) => {
    return (
      <div className={styles.tableContainer}>
        <div className={styles.headerContainer}>
          {this.renderSingleRow(headers, 'header')}
        </div>
        {content
          .filter(this.filterTag)
          .map((item, k) => this.renderSingleRow(item, 'content', k))}
      </div>
    );
  };

  getColor = (type, index, item) => {
    if (item && item.color) return item.color;
    const { rowColor, headerColor } = this.props;
    if (type === 'header' && headerColor) return headerColor;
    if (type !== 'header' && index === 0 && rowColor) return rowColor;
    return '#000';
  };

  getWidth = (index, length) => {
    if (index === 0) return '30%';
    return `${70 / (length - 1)}%`;
  };

  onSelect = (e, type) => {
    const { onSelect, data, headers } = this.props;
    let { checked } = this.state;
    if (!onSelect) return;
    const id = e.target.id;
    const value = e.target.checked;
    if (type === 'header') {
      if (value) {
        const keys = data.map(v => v[0].value);
        keys.push(headers[0]);
        checked = keys.reduce((acc, el) => {
          acc[el] = true;
          return acc;
        }, {});
      } else {
        checked = {};
      }
      onSelect('all', value);
    } else {
      if (value) {
        checked[id] = value;
      } else {
        delete checked[id];
      }
      onSelect(id, value);
    }
    this.setState({ checked });
  };

  renderSingleRow = (item, type, index) => {
    const {
      font,
      hasChildren,
      products,
      setProduct,
      updateProduct,
      onLeave,
      tags,
      hiderHiderCheckbox,
      scenes,
    } = this.props;
    const { checked, active, filterAlphabet } = this.state;
    const key = typeof item[0] === 'object' ? item[0].value : item[0];
    return (
      <div
        className={styles.singleRowContainer}
        style={{
          background: active[key] ? '#F7F7F7' : '',
          borderBottom:
            type === 'header' ? '1.2px #000 solid' : '1.2px #eaeaea solid',
        }}
      >
        {index % 23 === 0 && type !== 'header' && (
          <Waypoint
            key={index / 23}
            onEnter={e => onLeave && onLeave(index / 23, filterAlphabet)}
          />
        )}
        <div className={styles.singleRow}>
          {!(hiderHiderCheckbox && type === 'header') && (
            <Checkbox
              id={key}
              checked={checked[key]}
              className={styles.rowCheck}
              onChange={e => this.onSelect(e, type)}
            />
          )}
          {item.map((v, k) => (
            <div
              id={typeof v === 'object' ? v.value : v}
              className={
                type === 'header' || (k === 0 && font !== 'light')
                  ? styles.headerLabel
                  : styles.contentLabel
              }
              style={{
                cursor:
                  k === 0 || (v && v.pointer) || type === 'header'
                    ? 'pointer'
                    : '',
                width: '100%',
                color: this.getColor(type, k, v),
              }}
              onClick={e =>
                type === 'header'
                  ? this.onHeaderClick(v, k)
                  : this.toggleActive(v, k)
              }
            >
              {typeof v === 'object' ? v.label : v}
            </div>
          ))}
        </div>
        {hasChildren && active[key] && (
          <ConfigPanel
            tags={tags}
            scenes={scenes}
            setProduct={setProduct}
            product={products[key]}
            onClose={e => this.toggleActive(key)}
            updateProduct={updateProduct}
          />
        )}
      </div>
    );
  };

  filterByAlhpabet = e => {
    const letter = e.target.id;
    this.setState({ filterAlphabet: letter });
    const { fetchAplphabet } = this.props;
    if (fetchAplphabet) {
      fetchAplphabet({
        page: 0,
        friendlyName: letter,
      });
    }
  };

  onHeaderClick = (v, k) => {
    const { onHeaderClick } = this.props;
    if (onHeaderClick) onHeaderClick(k);
  };

  render() {
    let { includeAlphabet, headers, data } = this.props;
    const { filterAlphabet } = this.state;
    const alphabetArr = Array.from({ length: 26 }, (_, i) =>
      String.fromCharCode('A'.charCodeAt(0) + i)
    );

    return (
      <div className={styles.container}>
        {includeAlphabet && (
          <div className={styles.alphabetContainer}>
            {alphabetArr.map(v => (
              <div
                className={styles.singeAlphabet}
                key={v}
                style={{
                  borderBottom: filterAlphabet === v ? '3px solid #000' : '',
                }}
                id={v}
                onClick={this.filterByAlhpabet}
              >
                {v}
              </div>
            ))}
          </div>
        )}
        {this.renderTable(headers, data)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TableView/index.js